import SectionListItem, {SectionListItemProps} from './SectionListItem';

export type {SectionListItemProps};
export default SectionListItem;
